import { Box, SxProps } from "@mui/material";
import { CSSProperties, FC } from "react";
import { Link } from "react-router-dom";

type Props = {
  to: string;
  children?: React.ReactNode;
  text?: string;
  target?: string;
  rel?: string;
  style?: CSSProperties;
  sx?: SxProps;
  onClick?: () => void;
};

export const InternalLink: FC<Props> = ({
  to,
  children,
  text,
  target,
  rel,
  onClick,
  style = {},
  sx = {}
}) => {
  return (
    <Box
      sx={{
        display: "inline",
        "& a": {
          textDecoration: "none",
          color: "inherit"
        },
        "& a:hover": {
          textDecoration: "underline"
        },
        ...sx
      }}
      onClick={onClick}>
      <Link
        to={to}
        target={target}
        rel={rel}
        style={{
          ...style
        }}>
        {children || text}
      </Link>
    </Box>
  );
};
